import { render } from "./reset.vue?vue&type=template&id=4bdfe5bc&scoped=true"
import script from "./reset.vue?vue&type=script&lang=js"
export * from "./reset.vue?vue&type=script&lang=js"

import "./reset.vue?vue&type=style&index=0&id=4bdfe5bc&lang=scss&scoped=true"

import exportComponent from "/Users/admin/Codes/d86e-client-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bdfe5bc"]])

export default __exports__